module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"checkAvailability":"Tarkista saatavuus","ChangeProject":"Muuta projektia"},"en":{"checkAvailability":"Check Availability","ChangeProject":"Change Project"},"ro":{"checkAvailability":"Verificați disponibilitatea","ChangeProject":"Schimbați proiectul"}}')
  delete Component.options._Ctor
}
